import { memo, useContext } from 'react';
import { default as ReactGA4 } from 'react-ga4';
import cn from 'classnames';
import { Element, Image, RouterLink } from '@zmedia/bm-soccer-ui/components';
import { SearchDropdownContext } from '.';
import { ContentItem } from '@zmedia/bm-soccer-ui/modules/content';
import { TTabType } from './constant';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './search.module.scss';
interface IProps {
    onClick: () => void;
    isTopic?: boolean;
    index: number;
    item?: any;
    type: TTabType;
}

const SearchItem = ({ onClick, type, index, item }: IProps) => {
    const currFocus = useContext(SearchDropdownContext);

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        ReactGA4.event({
            category: 'mobile_search_soccer',
            action: 'clickSuggestion',
        });
    };

    const renderItem = () => {
        switch (type) {
            case 'news':
                const ContentItemComponent = (window as any).ContentItem
                    ? (window as any).ContentItem
                    : ContentItem;
                item.contentId = item.id;
                item.date = item.publishedDate || 0;
                item.tracking = '|soccer';
                return (
                    <ContentItemComponent
                        className={styles['soccer-content-item']}
                        tracking={`|soccer-search`}
                        item={item}
                    />
                );
            case 'players':
                return (
                    <RouterLink
                        to={`${URL_SOCCER_PAGE.SUBPATH}${item?.path}`}
                        className={cn(styles['search-content'], {
                            [styles[type]]: type,
                        })}
                        title={item.name}
                    >
                        <Image src={item.avatar} alt={item.name}></Image>
                        <Element>{item.name}</Element>
                    </RouterLink>
                );
            case 'teams':
                return (
                    <RouterLink
                        to={`${URL_SOCCER_PAGE.SUBPATH}${item?.path}`}
                        className={cn(styles['search-content'], {
                            [styles[type]]: type,
                        })}
                        title={item.name}
                    >
                        <Image src={item.logo} alt={item.name}></Image>
                        <Element>{item.name}</Element>
                    </RouterLink>
                );
            default:
                return (
                    <RouterLink
                        to={`${URL_SOCCER_PAGE.SUBPATH}${item?.path}`}
                        className={cn(styles['search-content'], {
                            [styles[type]]: type,
                        })}
                        title={item.name}
                    >
                        <Image src={item.logo} alt={item.name}></Image>
                        <Element>{item.name}</Element>
                    </RouterLink>
                );
        }
    };

    return (
        <Element
            renderAs="li"
            className={cn(styles['search-item'], {
                [styles['is-focus']]: currFocus === index,
            })}
        >
            <Element onClick={handleClick}>{renderItem()}</Element>
        </Element>
    );
};

export default memo(SearchItem);
